import { useAPI } from '@nexelem/api';
import { useQuery } from '@tanstack/react-query';

export const useLemmaMachineAreasList = (name?: string) => {
  const api = useAPI();

  return useQuery({
    queryKey: ['lemma-machine-areas-list', name],
    queryFn: () =>
      api.postBackMachineAreasListFilter({
        postBackMachineAreasListFilterRequest: {
          data: { name },
        },
      }),
    select: (response) => response.result.data ?? [],
  });
};
